import { DefaultButton, Dialog, DialogFooter, Panel, PrimaryButton, Stack, Text } from '@fluentui/react';
import { IIdentityPanelState } from 'features/IdentityPanel/IdentityPanel.state';
import { signOut } from 'kits/authKit';
import IvicosStrings from 'kits/language/stringKit';
import React from 'react';
import { idpService } from 'services/api/identity-provider.service';

const IdentityPanelView: React.FC<IIdentityPanelState> = (props) => {
    const { children, isPanelOpen, onPanelDismiss, visitorCheck, hideErrorDialog, toggleHideErrorDialog } = props;

    return (
        <Panel
            aria-label="identity-panel"
            isOpen={isPanelOpen}
            isLightDismiss
            onDismiss={() => {
                onPanelDismiss();
            }}
            headerText={IvicosStrings.identityPanelTitle}
            closeButtonAriaLabel={IvicosStrings.closeActionTitle}
            // Stretch panel content to fill the available height so the footer is positioned
            // at the bottom of the page
            hasCloseButton={true}
            isFooterAtBottom={true}
        >
            {/* This is where the children live, i.e. <UserProfile /> */}
            <Stack>{children}</Stack>
            <Stack horizontal style={{ position: 'absolute', bottom: 40, width: '100%' }}>
                <DefaultButton
                    iconProps={{ iconName: 'PowerButton' }}
                    text={IvicosStrings.signOutActionTitle}
                    onClick={() => {
                        if (visitorCheck.isVisitor) {
                            idpService.deleteVisitor(visitorCheck.visitorId);
                        }
                        setTimeout(() => {
                            signOut(false);
                        }, 200);
                    }}
                />
            </Stack>
            <Dialog
                hidden={hideErrorDialog}
                onDismiss={() => {
                    toggleHideErrorDialog();
                }}
            >
                <Stack tokens={{ childrenGap: 8 }}>
                    <Text variant="xLarge">{IvicosStrings.errorOccurred}</Text>
                    <Text>{IvicosStrings.somethingWentWrongNotificationActionTitle}</Text>
                </Stack>
                <DialogFooter>
                    <PrimaryButton
                        onClick={() => {
                            toggleHideErrorDialog();
                        }}
                        text={IvicosStrings.closeActionTitle}
                    />
                </DialogFooter>
            </Dialog>
        </Panel>
    );
};

export default IdentityPanelView;
